import { MISSING_JAPANESE_TRANSLATION_MESSAGE } from "constants/index";
import { MAP_TRANSLATION } from "constants/translation";

export const getTranslationKey = (value?: string, lowerkey = true) => {
  if (!value) return "";

  const sanitizedValue = value
    .replace(MISSING_JAPANESE_TRANSLATION_MESSAGE, "")
    .trim();

  const checkValue = lowerkey ? sanitizedValue.toLowerCase() : sanitizedValue;

  return MAP_TRANSLATION?.[checkValue] || sanitizedValue;
};
